import tempMee from '../apis/tempMee';
import { REFERRAL_ACTIONS, SHOW_MESSAGE } from './actionTypes';

import { getAuthHeaders } from './authActions';

export const fetchReferrals = (state) => async (dispatch, getState) => {
  try {
    let newSearchParams = {};
    if (state) {
      newSearchParams = {
        page: state?.page || 1,
        limit: 15,
        payFilter: state?.payFilter || '',
        referrerType: state?.referrerType || '',
        searchText: state?.searchText || '',
      };
    }

    const { searchParams } = getState().referral;
    if (JSON.stringify(searchParams) === JSON.stringify(newSearchParams) && !state?.refresh) {
      return;
    }
    dispatch({
      type: REFERRAL_ACTIONS.GET_REFERRAL_REQUEST,
      payload: newSearchParams,
    });
    const headers = await getAuthHeaders();
    const response = await tempMee.get('admin/referral', {
      params: newSearchParams,
      headers,
    });

    dispatch({ type: REFERRAL_ACTIONS.GET_REFERRAL_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: REFERRAL_ACTIONS.GET_REFERRAL_FAILURE, payload: err });
  }
};

export const cancelReferral = (id) => async (dispatch) => {
  try {
    dispatch({ type: REFERRAL_ACTIONS.CANCEL_REFERRAL_REQUEST });

    const headers = await getAuthHeaders();
    const response = await tempMee.patch(
      `/admin/referral/${id}`,
      { isCancelled: true },
      { headers },
    );

    dispatch({ type: REFERRAL_ACTIONS.CANCEL_REFERRAL_SUCCESS, payload: response.data });

    dispatch({
      type: SHOW_MESSAGE,
      payload: { message: 'The referral has been successfully cancelled.' },
    });
  } catch (err) {
    dispatch({ type: REFERRAL_ACTIONS.CANCEL_REFERRAL_FAILURE, payload: err });
  }
};
